/* Footer columns collapse into accordions on phones (Kalles pattern). With
   JS off every column stays expanded, which is the desktop rendering. */
(() => {
  const groups = Array.from(document.querySelectorAll('[data-mh-footer-group]'));
  if (!groups.length) return;
  const phoneQuery = window.matchMedia('(max-width: 749px)');

  const apply = () => {
    groups.forEach((group) => {
      const toggle = group.querySelector('[data-mh-footer-toggle]');
      const links = group.querySelector('[data-mh-footer-links]');
      if (!toggle || !links) return;
      const collapsed = phoneQuery.matches && group.dataset.mhFooterOpen !== 'true';
      // Above 750 px the heading is static: the button leaves the tab order and stops claiming a collapse state.
      toggle.disabled = !phoneQuery.matches;
      if (phoneQuery.matches) toggle.setAttribute('aria-expanded', String(!collapsed));
      else toggle.removeAttribute('aria-expanded');
      links.hidden = collapsed;
    });
  };

  groups.forEach((group) => {
    group.querySelector('[data-mh-footer-toggle]')?.addEventListener('click', () => {
      if (!phoneQuery.matches) return;
      group.dataset.mhFooterOpen = group.dataset.mhFooterOpen === 'true' ? 'false' : 'true';
      apply();
    });
  });

  phoneQuery.addEventListener('change', apply);
  apply();
})();
